/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Member_Detail_Standing_DeactivatedInputs */



/**
* | output |
* | --- |
* | "An administrator switched this member off. Their spaces, data and connected integrations are preserved, and reactivating them from the members list restores ..." |
*
* @param {Member_Detail_Standing_DeactivatedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const member_detail_standing_deactivated = /** @type {((inputs?: Member_Detail_Standing_DeactivatedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Member_Detail_Standing_DeactivatedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Ein Administrator hat dieses Mitglied abgeschaltet. Spaces, Daten und verbundene Integrationen bleiben erhalten; eine Reaktivierung in der Mitgliederliste stellt den Zugang wieder her.")
	return /** @type {LocalizedString} */ ("An administrator switched this member off. Their spaces, data and connected integrations are preserved, and reactivating them from the members list restores access.")
});